import React, {useContext} from "react";
import HelpComponent from "components/HelpComponent";
import YesNo from "components/YesNo";
import FormTranslationContext from "context/FormTranslationContext";

function NoticeYesNoInput
({
     id,
     label,
     formikProps,
     required,
     disabled
 }) {
    const {formTr, formTip} = useContext(FormTranslationContext)
    const tip = formTip(label ? label : id);


    const input = <YesNo
        id={id}
        label={formTr(label ? label : id)}
        formikProps={formikProps}
        required={required}
        skipCheckTouched
        disabled={disabled}
    />

    if (tip)
        return <HelpComponent text={tip}>
            {input}
        </HelpComponent>
    return input;


}

export default NoticeYesNoInput;